import {useInfiniteQuery, useQuery} from '@tanstack/react-query';
import {fetchColleagues, fetchMyColleagues, fetchUsersByIdList, fetchUsersByRole} from '../services/users';
import {UserRoles} from "../types/users";

export const useUsersByIdListQuery = (ids: string[] | undefined) => {
    return useQuery({
        refetchOnWindowFocus: false,
        queryKey: ['Users', ids],
        queryFn: () => fetchUsersByIdList(ids),
        enabled: !!ids
    });
};


export const useMyColleaguesQuery = (search: string | undefined, filter:any|undefined) => {
    const limit = 10;
    return useInfiniteQuery({
        queryKey: ['colleagues', search],
        queryFn: (
            {
                pageParam = {
                    limit: limit,
                    offset: 0
                }
            }
        ) => fetchMyColleagues(pageParam.limit, pageParam.offset, search),
        initialPageParam: {limit: limit, offset: 0},
        getNextPageParam: (lastPage, allPages) => {
            const nextOffset = allPages.flat().length;
            return lastPage.length !== 0 ? {limit: limit, offset: nextOffset} : undefined;
        },
    })
}


export const useColleaguesQuery = (search: string | undefined) => {
    const limit = 10;
    return useInfiniteQuery({
        queryKey: ['colleagues', search],
        queryFn: (
            {
                pageParam = {
                    limit: limit,
                    offset: 0
                }
            }
        ) => fetchColleagues(pageParam.limit, pageParam.offset, search),
        initialPageParam: {limit: limit, offset: 0},
        getNextPageParam: (lastPage, allPages) => {
            const nextOffset = allPages.flat().length;
            return lastPage.length !== 0 ? {limit: limit, offset: nextOffset} : undefined;
        },
    })
}


export const useUsersQuery = (search: string | undefined, role: UserRoles) => {
    const limit = 10;
    return useInfiniteQuery({
        queryKey: ['Users', 'all', search, role],
        queryFn: (
            {
                pageParam = {
                    limit: limit,
                    offset: 0
                }
            }
        ) => fetchUsersByRole(pageParam.limit, pageParam.offset, search, role),
        initialPageParam: {limit: limit, offset: 0},
        getNextPageParam: (lastPage, allPages) => {
            const nextOffset = allPages.flat().length;
            return lastPage.length !== 0 ? {limit: limit, offset: nextOffset} : undefined;
        },
    })
}